<template>
  <fragment>
      <b-form action="#" @submit="reportProjectData()">
        <b-alert show dismissible v-if="showAlert">
            <h3 class="alert-heading" v-if="showAlert">{{ $t('messages.success_title') }}</h3>
            <p>{{ $t('messages.success') }}</p>
        </b-alert>

        <b-list-group flush>
          <b-list-group-item>
              <b-form-group
              label-cols="12"
              label-cols-sm="4"
              label-cols-lg="3"
              label-for="totalCost"
              :label="$t('admin.deal_value_label') + ':'"
            >
              <b-input-group>
                <b-input
                  type="number"
                  id="totalCost"
                  v-model.number="form.totalCost"
                  :min="0"
                  :oninput="'validity.valid||(value=\'\');'"
                  required
                  aria-describedby="input-live-help input-live-feedback"
                ></b-input>
                {{ user.currency | currencySymbol }}
              </b-input-group>
              </b-form-group>
              
              <b-form-group
              label-cols="12"
              label-cols-sm="4"
              label-cols-lg="3"
              label-for="notification"
              :label="$t('admin.comment_from_byer_label') + ':'"
            >
              <b-input-group>
                <b-form-textarea
                  id="notification"
                  :maxlength="1000"
                  v-model="form.notification"
                  placeholder="Write the buyers comments here"
                  rows="4"
                />
              </b-input-group>
            </b-form-group>

            <b-button
            variant="outline-danger"
            pill
            block
            v-b-modal="'modal_cancel'"
          >
            {{ $t("buttons.no_deal") }}
          </b-button>

            <b-button
            variant="primary"
            block
            @click="reportProjectData()"
            :disabled="this.submitting"
          >
            {{ $t("buttons.final_price") }}
          </b-button>
          </b-list-group-item>
        </b-list-group>
          </b-form>

        <b-modal
        :id="'modal_cancel'"
        :title="$t('buttons.cancel')"
      >
      <p class="m-2">Are you sure?</p>

      <template v-slot:modal-footer="{ cancel }">
        <b-button class="float-right" @click="cancel">
          {{ $t('buttons.cancel') }}
        </b-button>

        <b-button
          class="float-right"
          variant="outline-success"
          @click="() => { form.cancelled = true; reportProjectData(); $bvModal.hide('modal_cancel'); }"
        >
          <b-icon icon="check-circle" />
          Yes
        </b-button>
      </template>
    </b-modal>
  </fragment>
</template>
<script>
import api from '../../api/api';

export default {
    props: {
      user: {
        default: () => {},
        type: Object,
      },
      projectId: {
        default: 0,
        type: Number,
      },
      externalWinner: {
        default: false,
        type: Boolean,
      }
    },
    data() {
        return {
            form: {
                totalCost: 0,
                notification: '',
                userId: 0,
                projectId: this.projectId,
                cancelled: false,
            },
            showAlert: false,
            submitting: false,
            cancelled: false,
        }
    },
    mounted() {
      this.setUserID();
    },
    methods: {
        toggleTableRow(item) {
            this.$set(item, '_showDetails', !item._showDetails);
        },
        setUserID() {
          if (!this.externalWinner) this.form.userId = this.user.userId;
        },
        reportProjectData() {
          this.submitting = true;

           api.reportProjectWinner(this.form)
             .then(() => this.showAlert = true)
             .finally(() => this.submitting = false, setTimeout(() => this.showAlert = false, 8000));

             this.$emit('submit');
        }
        }
    }
</script>